import UltMeta, { Meta } from "./UltMeta/index";

class Business extends UltMeta {
    CONTRACT = new Meta(1, "项目合同");
    GOODS = new Meta(2, "项目提货");
    RECEIPT = new Meta(3, "项目签收");
    RECONCILIATION = new Meta(4, "项目对账");
}

export const BUSINESS = new Business();

class Style extends UltMeta {
    OFFICIAL_SEAL = new Meta(1, "公章");
    SPECIAL_SEAL_WITH_STAR = new Meta(2, "专用章(带五角星)");
    SPECIAL_SEAL_WITHOUT_STAR = new Meta(3, "专用章(不带五角星)");
}
export const STYLE = new Style();
